import React, { useState, useEffect } from 'react';
import utils from '../../utils';
import __ from '../internetLanguage';
import Pagination from './Pagination';
import WebResult from './WebResult';
import ResultsSummary from './ResultsSummary';
import NoResults from './NoResults';
import solrInstances from '../solrInstances';
import searchStates from '../../searchStates';

export default function SpanishWebResults(props) {
	const [page, setPage] = useState(1);
	const [isNewSearch, setIsNewSearch] = useState(false);
	const [searchState, setSearchState] = useState(searchStates.READY);
	const [totalResults, setTotalResults] = useState(0);
	const [results, setResults] = useState([]);

	const form = props.form;
	const data = form.data;
	const isActive = props.isActive;
	const onTotalResultsUpdate = props.onTotalResultsUpdate;
	const isEmpty = utils.isFormEmpty(data);
	const solr = solrInstances.es.web;
	let resultIndex = 0;

	const doSearch = (pageNum) => {
		pageNum && setPage(pageNum);
		setSearchState(searchStates.SEARCHING);
		solr.query(data, { page: pageNum || page })
			.then((response) => {
				setTotalResults(response.total);
				setResults(response.results);
				if (response.error && !response.length) {
					setSearchState(searchStates.ERROR);
					console.error('Search: Podcast search error: ', response.error);
				} else {
					setSearchState(searchStates.DONE);
				}
			})
			.catch((error) => {
				console.error('Search: Podcast search fail: ', error);
				setSearchState(searchStates.ERROR);
			});
	};

	const clearResults = () => {
		setResults([]);
		setTotalResults(0);
		setPage(1);
	};

	const goToPage = (pageNum, anchor) => {
		if ('number' !== typeof pageNum || 1 > pageNum || pageNum === page) {
			return;
		}
		setResults([]);
		utils.toTop();
		doSearch(pageNum);
	};

	// On form change, update newSearch flag
	useEffect(() => {
		clearResults();
		if (!isEmpty) {
			setIsNewSearch(true);
		} else {
			setSearchState(searchStates.READY);
		}
	}, [data]);

	// On Active
	useEffect(() => {
		if (!isEmpty && isActive && isNewSearch) {
			doSearch();
			setIsNewSearch(false);
		}
	}, [isActive, isNewSearch]);

	useEffect(() => {
        if (onTotalResultsUpdate) {
            onTotalResultsUpdate(totalResults);
        }
    }, [totalResults]);

	let resultsOut = [];
	results.map((result) => {
		resultsOut.push(
			<WebResult key={resultIndex} resultIndex={resultIndex} result={result} page={page} query={data.query} />
		);
		resultIndex++;
	});


	return (
		<div className="results webResults" data-cdc-total={totalResults}>
			<ResultsSummary
				isEmpty={isEmpty}
				isAdvanced={true}
				resultType="podcast"
				page={page}
				searchState={searchState}
				totalResults={totalResults}
				form={form}
			/>

			{!results.length ? (
				<NoResults isEmpty={isEmpty} searchState={searchState} />
			) : (
				<div>
					{resultsOut}

					<Pagination
						page={page}
						totalResults={totalResults}
						goToPage={goToPage}
						anchor="#results"
					/>
				</div>
			)}
		</div>
	);
}
